import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, createStyles, makeStyles, Theme } from '@material-ui/core';

import { TableCommon } from '../../../shared/components/TableCommon';
import { Column, Options } from 'material-table';
import NewsService from '../../../Services/NewsService';
import { HomeContext } from '../../Home/HomeContext';
import { NewsModel } from '../../../Models/NewsModel';
import { TableLoading } from '../../../shared/components/TableLoading';
import { SearchStatus } from '../../../shared/enum/SearchStatus';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { NewsStatus } from '../../Classification/enum/NewsStatus';
import { BasicPage } from '../../../shared/components/BasicPage';

const useStyles = makeStyles((theme: Theme) => createStyles({
    tablesGrid: {
        marginTop: theme.spacing(7),
        display: 'grid'
    }
}));

export function NewsMetric() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);

    const [searchStatus, setSearchStatus] = React.useState<SearchStatus>(SearchStatus.LOADING);
    const [newsList, setNewsList] = React.useState<NewsModel[]>([]);

    React.useEffect(() => {
        if(homeContext.spreadsheetId){
            NewsService.getAll(homeContext.spreadsheetId , NewsStatus.CLASSIFIED)
                .then((res: AxiosResponse) => {
                    setNewsList(res.data);
                    if (res.data.length > 0)
                        setSearchStatus(SearchStatus.RESULT);
                    else
                        setSearchStatus(SearchStatus.EMPTY);
                })
                .catch((error: AxiosError) => {
                    setSearchStatus(SearchStatus.EMPTY);
                    homeContext.showError('', error);
                });
        }
    },[homeContext.spreadsheetId]);

    const tableColumns: Column<NewsModel>[] = [
        {
            title: 'Id Notícia',
            field: 'id',
            type: 'string',
            align: 'left',
            cellStyle: { width: '10%'}
        },
        {
            title: 'Título da publicação',
            field: 'title',
            type: 'string',
            align: 'left',
            cellStyle: { width: '70%'},
            defaultSort: 'asc'
        },
        {
            title: 'ID Classificação',
            field: 'classificationId',
            type: 'string',
            align: 'left',
            cellStyle: { width: '10%'},
            render: (rowData) => rowData.classificationId || 'Não Classificado'
        }
    ];

    const tableOptions: Options<NewsModel> = {
        filtering: true,
        toolbar: false,
        showTitle: false,
        pageSizeOptions: [10, 50, 100, 200],
        pageSize: 50
    };

    return(
        <BasicPage
            title="IDs gerados"
            subtitle="Utilize os IDs para realizar consultas e alterações de classificação no sistema.">
            <Grid container className={classes.tablesGrid}>
                { searchStatus === SearchStatus.LOADING && 
                    <TableLoading displayText='Carregando notícias'/>
                }
                { searchStatus === SearchStatus.RESULT && (
                    <TableCommon
                        tableData={newsList}
                        tableColumns={tableColumns}
                        emptyDataSourceMessage='Nenhuma notícia a ser exibida.'
                        extraOptions={tableOptions} />
                )}
                { searchStatus===SearchStatus.EMPTY &&
                    <TableEmpty displayText='Nenhuma notícia encontrada.'/>
                }
            </Grid>
        </BasicPage>
    );
}